import actionTypes from "../actions/actionTypes";

const initialState = {
    rules: null
}
function RecurringPaymentReducers(state = initialState, action) {

    switch (action.type) {
        case actionTypes.GET_RECURRING_DATA:
            return {
                ...state,
                rules: action.payload,
            }
        default: return state;
    }
}
export default RecurringPaymentReducers;